/* eslint-disable no-console */
<!--  -->
<template>
  <div class="sub-text">
      <tem-head :globalConfig='globalConfig' v-if="temData.title" :text="temData.title" />
      <div class="description" :style='setColor'>{{ temData.description }}</div>
      <div class="card-list" :style="temData.hasBorder ? setBorder:''">
        <Card 
          v-for="(item, i) in temData.subjectDtoList" 
          :key="i" 
          :info="item"
          :moduleId="temData.id"
          :globalConfig='globalConfig'
          @handleClick='jumpSubject'
        />
      </div>
  </div>
</template>

<script>
import TemHead from '@/components/TemHead'
import Card from '@/components/subCard'
import { mapState } from 'vuex'
export default {
  props: {
    temData: {
      type: Object
    }
  },
  computed: {
    ...mapState({
        globalConfig: state => state.router.globalConfig,
    }),
    setColor(){
      return{
        color:this.globalConfig.main
      }
    },
    setBorder(){
      const border = {
        'border-width': '1px',
        'border-style': 'solid',
        'border-radius': '8px'
      }
      return{
        'borderColor':this.globalConfig.vice,
        ...border
      }
    }
  },

  components: {
    TemHead,
    Card
  },

  methods: {
    async jumpSubject({bundleId}) {
      this.$router.push({
        name: 'StudentComplier',
        query:{
          bundleId,
          back: this.$route.fullPath, 
        }
      })
    }
  }
}

</script>
<style lang='less' scoped>
.card-list {
  width: 1100px;
  margin:0 auto;
  // margin-top: 56px;
  padding-top: 40px;
  display: flex;
  justify-content: space-around;
  padding-bottom: 56px;
}
.sub-text{
  text-align: center;
}
.description {
  color: #fff;
  padding: 40px 350px 10px 350px;
  font-weight: 500;
  margin-bottom: 32px;
}
</style>